/* eslint react-hooks/exhaustive-deps: "warn" */

import NextLink from 'next/link';

import { useInt } from 'hooks/useInt';

import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './IndexEditorial.module.scss';

import { IndexSection } from '../../atoms/IndexSection/IndexSection';
import { getEditorialPicks } from '../../HubListPage.data';
import { topicPath } from '../../paths';
import type { IndexEditorialProps } from './IndexEditorial.types';

export const IndexEditorial = ({ lang, className }: IndexEditorialProps) => {
  const { t } = useInt();

  return (
    <IndexSection
      title={t('Start with the question you need to answer.')}
      aside={t('Practical reading across identity, credit, ownership and company data.')}
      className={className}
    >
      <ul className={styles['grid']}>
        {getEditorialPicks(t).map((pick) => (
          <li key={pick.slug} className={styles['cell']}>
            <NextLink href={topicPath(pick.slug, lang)} className={styles['card']}>
              <span className={styles['eyebrow']}>{pick.eyebrow}</span>

              <span className={styles['title']}>{pick.title}</span>

              <span className={styles['description']}>{pick.description}</span>

              <span className={styles['more']}>
                {t('Read the guide')}
                <Icon type="arrow-forward" />
              </span>
            </NextLink>
          </li>
        ))}
      </ul>
    </IndexSection>
  );
};
